import { useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import { CloseIcon } from 'Asset/icon';

import HostTaskSubmissionProvider from 'View/host-task-submission/state';
import FormUpsert from 'View/host-task-submission/section/form';

import styles from './styles.module.css';

const HostTaskSubmission = () => {
  const navigate = useNavigate();

  const onClose = () => {
    navigate('/host');
  };

  return (
    <Box>
      <Box className={styles['form__section--head']}>
        <CloseIcon size="18px" onClick={onClose} className={styles['form__head-icon']} />
      </Box>
      <Box className={styles['task_submission__container']}>
        <FormUpsert />
      </Box>
    </Box>
  );
};

const HostTaskSubmissionContainer = () => <HostTaskSubmissionProvider children={<HostTaskSubmission />} />;

export default HostTaskSubmissionContainer;
